import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';

interface AccordionWrapperProps {
  title?: string;
  items: any[];
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: theme.spacing(1, 0, 2, 0),
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(1.5),
      },
    },
    title: {
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(0),
      },
    },
  }),
  { name: 'AccordionWrapper' },
);

const AccordionWrapper: React.FC<AccordionWrapperProps> = (props: any) => {
  const classes = useStyles(props);
  const [expanded, setExpanded] = React.useState<boolean | string>(false);

  const handleChange: any = (panel: string) => (event: EventTarget, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const collapse: () => void = () => setExpanded(false);
  const { title, items, children } = props;
  if (!items.length) return null;
  return (
    <div className={classes.root}>
      {title && title.length && (
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
      )}
      {items.map((Item: any, index: number) => {
        const key = index + 1;
        const id = `panel${key}`;
        const isExpanded = expanded === id;
        return children(Item, index, isExpanded, handleChange(id), collapse);
      })}
    </div>
  );
};

export default AccordionWrapper;
